/* eslint-disable jsx-a11y/label-has-associated-control */

import React from "react";
import { useContext } from "../../../context";
import {
  convertTime12to24,
  getTimeFormat,
} from "../../../../../../../../../Utils";
import { DEFAULT_TIME_FORMAT } from "../../../../../../../../../consts/general";

export function EndsAt() {
  const { appointment } = useContext();

  return (
    <div className="detail-row">
      <label>Appointment ends at:</label>
      <span>
        {getTimeFormat() !== DEFAULT_TIME_FORMAT
          ? convertTime12to24(appointment.endTime)
          : appointment.endTime}
      </span>
    </div>
  );
}
